import { useEffect, useRef, useState } from "react";

function useInView() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return { ref, inView };
}

const benefits = [
  {
    icon: "ri-microscope-line",
    title: "Enfoque Científico-Energético",
    desc: "Integramos la evidencia científica con el conocimiento energético ancestral para ofrecer una formación completa, rigurosa y transformadora.",
  },
  {
    icon: "ri-award-line",
    title: "Certificaciones Reconocidas",
    desc: "Nuestros diplomas y certificaciones son reconocidos a nivel nacional e internacional, abriendo puertas en el mundo de las terapias alternativas.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Acompañamiento Personalizado",
    desc: "Cada alumno recibe seguimiento individual. No eres un número: eres parte de una comunidad comprometida con tu crecimiento.",
  },
  {
    icon: "ri-refresh-line",
    title: "Resultados Comprobados",
    desc: "Más de 500 alumnos certificados con casos de éxito documentados en salud, bienestar y desarrollo profesional en toda Latinoamérica.",
  },
  {
    icon: "ri-book-open-line",
    title: "Metodología Integral",
    desc: "Combinamos múltiples técnicas en un sistema coherente que aborda al ser humano en su totalidad: cuerpo, mente, emoción y energía.",
  },
  {
    icon: "ri-community-line",
    title: "Comunidad Activa",
    desc: "Al certificarte, ingresas a una red de terapeutas y profesionales que se apoyan mutuamente, comparten casos y siguen creciendo juntos.",
  },
];

export default function Benefits() {
  const { ref, inView } = useInView();

  return (
    <section className="py-20 md:py-32 bg-[#0A1F44]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className={`text-center mb-14 md:mb-20 transition-all duration-700 ${inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase">¿Por qué elegirnos?</span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mt-3 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Metodología integral,<br />
            <span className="text-[#D4AF37]">resultados comprobados</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-2xl mx-auto">
            No enseñamos técnicas aisladas. Formamos terapeutas completos con visión integral y herramientas reales para transformar vidas.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              className={`bg-white/5 border border-white/10 rounded-2xl p-7 hover:border-[#D4AF37]/40 hover:bg-white/8 transition-all duration-500 ${
                inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#D4AF37]/15 text-[#D4AF37] mb-5">
                <i className={`${b.icon} text-xl`}></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                {b.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
